// initial state
const state = {
		user: null,
    redirectToken: null,
		device: {},
		deviceRegistered: false,
		editedClinics: [],
    serviceVersion: 'unknown',
}

// getters
const getters = {
}

// actions
const actions = {
}

// mutations
const mutations = {
  setUser(state, user) {
    state.user = user;
  },
  setRedirectToken(state, redirectToken) {
    state.redirectToken = redirectToken;
  },
  setDevice(state, device) {
    state.device = device;
		state.deviceRegistered = true;
  },
  setDeviceUuid(state, deviceUuid) {
    state.device.uuid = deviceUuid;
  },
  setDevicePlatform(state, devicePlatform) {
    state.device.platform = devicePlatform;
  },
  setDeviceVersion(state, deviceVersion) {
    state.device.version = deviceVersion;
  },
  setDeviceToken(state, deviceToken) {
    state.device.token = deviceToken;
  },
	setDeviceAllowNotifications(state, allowNotifications) {
    state.device.allowNotifications = allowNotifications;
  },
  addEditedClinic(state, editedClinic) {
		var index = state.editedClinics.findIndex(x => x.clinic.id == editedClinic.clinic.id);
		if (index != -1) {
			state.editedClinics.splice(index, 1, editedClinic);
		} else {			
			state.editedClinics.push(editedClinic);
		}
  },
  clearEditedClinics(state) {
		state.editedClinics = [];
	},
  setServiceVersion(state, serviceVersion) {
    state.serviceVersion = serviceVersion;
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}